// extracted by mini-css-extract-plugin
export default {"footerContainer":"footerContainer-CDaiYZhX","buttons":"buttons-q93Uvqi6","button":"button-jGzzRyGs"};